import DashIcon from '../../components/ui/DashIcon'
import DashAvatar from '../../components/ui/DashAvatar'
import StatusBadge from '../../components/ui/StatusBadge'
import { seed } from '../../components/admin/mockData'

// WIP — aucun endpoint backend n'existe pour agréger les clients d'un expéditeur
// (pas de route /api/.../clients, pas de modèle Client dédié). Cette page affiche
// des données factices générées côté client en attendant que la feature soit
// spécifiée et implémentée côté API.
export default function ExpediteurClients() {
  const clients = seed(8).map((p, i) => ({
    ...p,
    orders:  8  + (i * 7)   % 48,
    revenue: 320 + (i * 180) % 1800,
    status:  i === 2 ? 'suspended' : 'active',
    lastDate: `${14 + i} mai`,
    phone: `+216 ${20 + i}${i * 3}${i * 7}${i * 2}${i + 1}`,
  }))

  return (
    <>
      <div className="page-head">
        <div className="ph-titles">
          <h1>Mes clients</h1>
          <p>Carnet d'adresses et historique par client.</p>
        </div>
        <div className="ph-actions">
          <button className="btn btn-ghost"><DashIcon name="download" size={14} /> Export</button>
          <button className="btn btn-primary"><DashIcon name="plus" size={14} /> Ajouter client</button>
        </div>
      </div>

      <div style={{
        background: 'var(--green-50)', border: '1px solid var(--green-100)',
        borderRadius: 'var(--r)', padding: '12px 16px', marginBottom: 16,
        fontSize: '0.85rem', color: 'var(--text)',
      }}>
        🚧 Fonctionnalité en construction — les données ci-dessous sont factices (démo). Aucun endpoint backend n'existe encore pour cette page.
      </div>

      <div className="tbl-card">
        <div className="tbl-scroll">
        <table className="tbl">
          <thead>
            <tr>
              <th>Client</th><th>Ville</th><th>Téléphone</th>
              <th>Colis livrés</th><th>Revenu total</th><th>Dernier colis</th>
              <th>Statut</th><th className="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((c) => (
              <tr key={c.name}>
                <td>
                  <div className="cell-user">
                    <DashAvatar name={c.name} size={32} />
                    <div><b>{c.name}</b><span>{c.company}</span></div>
                  </div>
                </td>
                <td>{c.city}</td>
                <td className="mono">{c.phone}</td>
                <td className="mono row-strong">{c.orders}</td>
                <td className="mono">{c.revenue} DT</td>
                <td style={{ color: 'var(--muted)' }} className="mono">{c.lastDate}</td>
                <td><StatusBadge status={c.status} /></td>
                <td className="col-actions">
                  <button>Voir</button>
                  <button><DashIcon name="more" size={14} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </>
  )
}
